import { FC } from 'react'
import Link from 'next/link'
import styles from './index.module.scss'
import { ICompanyBase } from '../../../types'
import { Avatar } from '../../atoms/Avatar'
import { getCompanyLogo } from '../../../utils'

type Props = {
  company: ICompanyBase
  small?: boolean
}

export const CompanyLogoAndName: FC<Props> = ({ company, small = false }) => {
  return (
    <div className={styles.container}>
      <Link href={`/companies/${company?.slug}`}>
        <a className={styles.link}>
          <div className={small ? styles.smallLogo : styles.logo}>
            <Avatar src={getCompanyLogo(company)} alt={company?.name} />
          </div>
          <span className={styles.name}>{company?.name}</span>
        </a>
      </Link>
    </div>
  )
}
